import { Link } from "@tanstack/react-router"
import type { ReactNode } from "react"

import { accessStore } from "../access/access-store"
import type { ThemeMode } from "../theme/theme"
import { useTheme } from "../theme/use-theme"
import styles from "./user-panel.module.css"

/**
 * Подвал навигации: кто вошёл, кем он здесь работает и как выйти.
 *
 * ЗАЧЕМ ЗДЕСЬ НАЗВАНИЕ РОЛИ. Человек работает мастером в одной студии и администратором
 * в другой, и набор разделов у него в этих салонах разный. Увидев два пункта меню вместо
 * восьми, он должен прочитать причину («Мастер»), а не заподозрить поломку.
 *
 * ЗАЧЕМ ЗДЕСЬ ТЕМА. Тёмная тема кабинета — не системная настройка устройства, а выбор
 * человека: мастеру она нужна в зале с приглушённым светом независимо от того, что стоит
 * в телефоне, а администратору за стойкой — светлая при системной тёмной. Поэтому выбор
 * стоит рядом с профилем, а не прячется в настройках салона: он личный и меняется часто.
 */

const THEME_OPTIONS: readonly { readonly value: ThemeMode; readonly label: string }[] = [
  { value: "light", label: "Светлая" },
  { value: "dark", label: "Тёмная" },
  { value: "system", label: "Как в системе" },
]

function isThemeMode(value: string): value is ThemeMode {
  return value === "light" || value === "dark" || value === "system"
}

export function UserPanel(props: {
  readonly userName: string
  readonly roleName: string
  /** На бордовой навигации подвал пишется светлым, во всплывающем меню — обычным текстом. */
  readonly onNav?: boolean
}): ReactNode {
  const theme = useTheme()
  const onNav = props.onNav ?? false

  return (
    <div className={onNav ? styles.panelOnNav : styles.panel}>
      <div className={styles.name}>{props.userName}</div>
      <div className={styles.role}>
        {props.roleName} ·{" "}
        <Link to="/profile" className={styles.signOut}>
          профиль
        </Link>{" "}
        ·{" "}
        <button
          type="button"
          className={styles.signOut}
          onClick={() => {
            void accessStore.signOut()
          }}
        >
          выйти
        </button>
      </div>

      <label className={styles.theme}>
        <span className={styles.themeLabel}>Тема</span>
        <select
          className={styles.themeSelect}
          value={theme.mode}
          onChange={(event) => {
            const next = event.currentTarget.value
            if (isThemeMode(next)) theme.setMode(next)
          }}
        >
          {THEME_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </label>
    </div>
  )
}
